import React from 'react';

const Page = ({ children }) => (
  <div className="py-8 px-4">
    {children}
  </div>
);

export default Page;
